/*
---
author:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.4.5: '*'
...
*/

var RegistrationPopup = new Class({
  Implements: [Events, Options],

  initialize: function(element, options){
    if(!element) return;

    this.setOptions(options);

    this._element = element;

    this.build();
  },

  build: function(){
    var self = this;

    this.active = true;

    this._signin_form = this._element.getElement('.w_form._sign_in');

    if(this._signin_form){
      this._signin_form.fade('hide');
      this._signin_form.form = this._signin_form.getElement('form');
    }

    this._signup_form = this._element.getElement('.w_form._sign_up');
    this._signup_form.form = this._signup_form.getElement('form');

    this._first_step = this._signup_form.getElement('.first_step');
    this._second_step = this._signup_form.getElement('.second_step');

    if(Core.is_ie8()){
      var _h3s = this._element.getElements('.left_side .feature h3');

      _h3s.each(function(_el){
        _el.addClass('_lighter');
      })
    }

    var _fields = this._element.getElements('input[type!="hidden"]');

    _fields.each(function(_el){
      _el.addEvents({
        'blur': function(e){
          if(_el.get('type') == 'submit') return;

          var silent_validation = true;

          if(_el.getParent('.form_item._failed')){
            silent_validation = false;
          }

          if( self.check_required(_el, silent_validation) &&
              self.check_length(_el, silent_validation) &&
              self.check_format(_el, silent_validation) &&
              self.check_budget(_el, silent_validation)){
            self.hide_advice();

            if(!_el.hasClass('_email')){
              _el.addClass('_valid');
            }
          }else{
            _el.removeClass('_valid');
          }
        }
      });
    });

    this._email_field = this._element.getElement('#email_li input');

    if(this._email_field && !this._email_field.getAttribute('nobluraction')){
      this._email_field.addEvent('blur', function(e){
        self.validate_email();
      });
    }

    this._email_confirmation_button = this._signup_form.getElement('.button._run_email_confirmation');

    if(this._email_confirmation_button){
      this._email_confirmation_button.addEvent('click', function(e){
        if(e && e.stop) e.stop();

        if(!self.active) return;

        self._email_confirmation_button.addClass('_clicked');

        self.validate_email();
        self.submit_email_confirmation();
      });
    }

    this._second_step_button = this._signup_form.getElement('.button._run_second_step');

    if(this._second_step_button){
      this._second_step_button.addEvent('click', function(e){
        if(e && e.stop) e.stop();

        if(!self.active) return;

        self._second_step_button.addClass('_clicked');

        self.submit_first_step();
      });
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////
    // for testing different steps:
    // this.display_second_step();
    // this.display_thankyou();
    ///////////////////////////////////////////////////////////////////////////////////////////////////

    this._third_step_button = this._element.getElement('.second_step .button._run_third_step');

    if(this._third_step_button){
      this._third_step_button.addEvent('click', function(e){

        if(!self.active) return;

        self.submit_second_step(e);
      });
    }

    if(this._signin_form){
      this._signin_button = this._signin_form.getElement('input[type="submit"]');

      this._signin_form.form.addEvents({
        'submit': function(e){
          self.run_signin(e);

        }
      });

      Core.add_form_support(this._element.getElement('.w_form._sign_in'));
    }

    this._signin_toggle = this._element.getElement('.signin_toggle');

    if(this._signin_toggle){
      this._signin_toggle.addEvent('click', function(e){
        if(e && e.stop) e.stop();

        if(!self.active) return;

        self.slide('out');
      });
    }

    this._signup_toggle = this._element.getElement('.signup_toggle');

    if(this._signup_toggle){
      this._signup_toggle.addEvent('click', function(e){
        if(e && e.stop) e.stop();

        if(!self.active) return;

        self.slide('in');
      });
    }

    this._validation_advice = this._element.getElement('.validation_advice');
    this._validation_advice.text = this._validation_advice.getElement('.msg');

    this.fix_tab_key();
    new Numeric(this._signup_form.form);
	},

  submit_email_confirmation: function(){
    var self = this;

    if(this.validating_email){
      this._first_step.addClass('_loading');
      this.active = false;

      (function(){
        self.submit_email_confirmation();
      }).delay(100);

      return;
    }else{
      this._first_step.removeClass('_loading');
      this.active = true;

      if(this.email_exists){
        Core.shake_element(this._second_step_button);
        this.show_advice(this._email_field, 'data-error-exists', this.email_exists);
        return;
      }else{
        this.active = false;
        window.location = window.location; //we always reload page after email verification
      }
    }

    this.hide_advice();
  },

  submit_first_step: function(){
    var self = this;

    if(!this.validate_first_step()){
      Core.shake_element(this._second_step_button);
      return;
    }

    if(this.validating_email){
      this._first_step.addClass('_loading');
      this.active = false;

      (function(){
        self.submit_first_step();
      }).delay(100);

      return;
    }else{
      this._first_step.removeClass('_loading');
      this.active = true;

      if(this.email_exists){
        Core.shake_element(this._second_step_button);
        this.show_advice(this._email_field, 'data-error-exists', this.email_exists);
        return;
      }else{
        var action = this._signup_form.form.getProperty('action');
        var data = this._signup_form.form.toQueryString().trim() + '&ajax=1';
        this.first_step_finished = false;

        new Request.JSON({
          data: data,
          url: action,
          noCache: true,

          onSuccess: function(data){
            self.reload_on_signup = (data.FormRegistrationPopup_redirectTo != null && data.FormRegistrationPopup_redirectTo[0] != null && data.FormRegistrationPopup_redirectTo[0].url != null);
            self.redirect_to = data.FormRegistrationPopup_redirectTo[0].url;
            self.first_step_finished = true;

            if(self.third_step_button_clicked){
            	self.ready_for_signup = true;
        		self.submit_second_step();
        	}
          }
        }).post();

        G = false;

        $$('._guest_item').each(function(_el){
        	if(_el.hasClass('w_blimp_box')) return;

        	_el.dispose();
        });

		  	$$('._registered_user_item').show();

        this.inject_name();
        this.display_second_step();

        var src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'clickserv.sitescout.com/conv/0e0479614c7f1891';
        new Asset.image(src, { //tracking image
					onLoad: function(){}
				});
      }
    }

    this.hide_advice();
  },

  submit_second_step: function(e){
    var self = this;

    if(e && e.stop) e.stop();

    if(!this.ready_for_signup) return;

    this.hide_advice();

    if(!this.validate_second_step()){
      Core.shake_element(this._third_step_button);
      return;
    }

    this.ready_for_signup = false;

    this._second_step.addClass('_loading');
    this.active = false;

    if (!self.first_step_finished) {
    	//to determine if the user clicked the button in the second step while the rpc of the first step is not finished yet.
      	self.third_step_button_clicked = true;

    	return
    }

    var query = self._signup_form.form.toQueryString();

    new Request.JSON({
      data: query,
      url: self._signup_form.form.getAttribute('data-registration-profile'),
      noCache: true,

      onSuccess: function(data){
        self._second_step.removeClass('_loading');
        self.active = true;

        var error = self.display_second_step_errors(data);

        if(error){
          Core.shake_element(self._third_step_button);

          var _field;
          var msg;

          if(error.budget){
            _field = self._signup_form.getElement('#FormRegistrationPopup_budget');
            msg = error.budget;
          }else if(error.phone){
            _field = self._signup_form.getElement('#FormRegistrationPopup_phone');
            msg = error.phone;
          }

          self.show_advice(_field, 'data-error-format', msg, true);

          self.ready_for_signup = true;
          return;
        }

        self.display_thankyou();
      }
    }).post();
  },

  run_signin: function(e){
    if(e && e.stop) e.stop();

    if(!this.active) return;

    this.hide_advice();

    var self = this;
    this._err = this._signin_form.getElement('.login_failed');

    if(this._err) this._err.hide();

    if(this.validate_signin()){
      var action = this._signin_form.form.getProperty('action');
      var data = this._signin_form.form.toQueryString().trim() + '&ajax=1';

      this._signin_form.addClass('_loading');
      this.active = false;

      new Request.JSON({
        data: data,
        url: action,
        noCache: true,

        onSuccess: function(data){
          self.post_signin(data);
        }
      }).post();
    }else{
      Core.shake_element(this._signin_button);
    }
  },

  post_signin: function(data){
  	if(data && data.RPCFormLogin_FORMSUMMARY && data.RPCFormLogin_FORMSUMMARY[0] && data.RPCFormLogin_FORMSUMMARY[0].status == true){

      if(_gaq)
      	_gaq.push(['_trackEvent', 'Registration', 'Loaded', 'registration-member-login']);

      var _wm = this._signin_form.getElement('.welcome_message');

      if(_wm) _wm.show();

      //CRFOUR-290, display the save listing message.
      this.show_save_listing_message(data);

      this.active = false;

      var redirect_to = data.RPCFormLogin_FORMSUMMARY[0].redirectTo;

      if(redirect_to || redirect_to == ''){
     		window.location = (redirect_to == ''? window.location : redirect_to);
      }else{
      	G = false;
		  	$$('._guest_item').dispose();
		  	$$('._registered_user_item').show();


      	(function(){
	      	Blimp.instances.each(function(el){
						el.hide();
					});
      	}.bind(this)).delay(2000);
      }
    }else{
      if(this._err) this._err.show();

      this.active = true;
    }

    this._signin_form.removeClass('_loading');
  },

  post_signup: function(data){
  	if(this.reload_on_signup == false){
  		Blimp.instances.each(function(el){
				el.hide();
			});

  		return;
  	}

  	if(this.redirect_to){
     	window.location = (this.redirect_to == ''? window.location : this.redirect_to);
    }else{
    	window.location = window.location;
    }

    this.active = false;
    this._signin_form.removeClass('_loading');
  },

  validate_first_step: function(){
    var self = this;
    var valid = true;
    var _fields = this._signup_form.getElements('.first_step input[type!="hidden"]');

    _fields.some(function(_el){
      if(!self.check_required(_el, false)){
        valid = false;
        self.focus(_el);
        return true;
      }

      if(!self.check_length(_el, false)){
        valid = false;
        self.focus(_el);
        return true;
      }

      if(!self.check_format(_el, false)){
        valid = false;
        self.focus(_el);
        return true;
      }
    });

    return valid;
  },

  validate_second_step: function(){
    ////////////////////////////////////////////////////////////////////////////////////
    // for testing second step backend
    // return true;
    ////////////////////////////////////////////////////////////////////////////////////

    var self = this;
    var valid = true;
    var _fields = this._signup_form.getElements('.second_step select, .second_step input[type!="hidden"]');

    _fields.some(function(_el){
      if(!self.check_required(_el, false)){
        valid = false;
        self.focus(_el);
        return true;
      }

      if(!self.check_format(_el, false)){
        valid = false;
        self.focus(_el);
        return true;
      }

      if(!self.check_budget(_el, false)){
        valid = false;
        self.focus(_el);
        return true;
      }
    });

    return valid;
  },

  validate_signin: function(){
    var self = this;
    var valid = true;
    var _fields = this._signin_form.getElements('input[type!="hidden"]');

    _fields.some(function(_el){
      if(!self.check_required(_el, false)){
        valid = false;
        self.focus(_el);
        return true;
      }

      if(!self.check_format(_el, false)){
        valid = false;
        self.focus(_el);
        return true;
      }
    });

    return valid;
  },

  validate_email: function(){
    var self = this;

    var _field = this._email_field;

    if(this.check_required(_field, true) && this.check_format(_field, true)){
      this.validating_email = true;

      var data = {
        'FormRegistrationPopupValidation[email]': _field.get('value')
      }

      var rpc_url = this._signup_form.form.getAttribute('data-registration-validation');

      if(!rpc_url || rpc_url == ''){
        this.validating_email = false;
        return;
      }
	      self.rqt = new Request.JSON({
	        data: data,
	        url: rpc_url,
	        noCache: true,

	        onSuccess: function(data){
	          if(data.FormRegistrationPopupValidation_email){
	            self.email_exists = data.FormRegistrationPopupValidation_email[0];

	            if(!self.showing_error){
	              self.show_advice(_field, 'data-error-exists', data.FormRegistrationPopupValidation_email[0]);
	            }
	          }else{
	            if(self._validation_advice.hasClass('_email')){
	              self.hide_advice();
	            }

	            self.email_exists = false;

	            _field.addClass('_valid');
	          }

	          self.validating_email = false;
	        }
	      }).post();
    }
  },

  check_required: function(_field, silent_validation){
    if(!_field.hasClass('required')) return true;

    var _parent = _field.getParent('li') || _field.getParent();
    _parent.removeClass('_failed');

    var type = _field.get('type');

    var valid = true;

    if((type == 'text' || type == 'password') && _field.get('value').trim() == ''){
      _field.set('value', '');

      valid = false;
    }else if(type == 'checkbox' && !_field.checked){
      valid = false;
    }else if(type == 'select-one' && (!_field.getElement(':selected') || _field.getElement(':selected').hasClass('_default'))){
      valid = false;
    }

    if(!valid && !silent_validation){
      this.show_advice(_field, 'data-error-required', 'This field is required.');
    }

    return valid;
  },

  check_length: function(_field, silent_validation){
    var type = _field.get('type');

    if(!(type == 'text' || type == 'password')) return true;

    var _parent = _field.getParent('li') || _field.getParent();
    _parent.removeClass('_failed');

    var valid = true;

    var min = _field.getAttribute('data-min-length') || _field.get('minlength');

    if(min){
      min = min.toInt();

      var length = _field.get('value').length;

      if(length < min){
        if(!silent_validation){
          this.show_advice(_field, 'data-error-min-length', 'The value of the field is too short.');
          this.focus(_field);
        }

        valid = false;
      }
    }

    var max = _field.getAttribute('data-max-length') || _field.get('maxlength');

    if(max && valid){
      max = max.toInt();

      var length = _field.get('value').length;

      if(length > max){
        if(!silent_validation){
          this.show_advice(_field, 'data-error-max-length', 'The value of the field is too long.');
        }

        valid = false;
      }
    }

    return valid;
  },

  check_format: function(_field, silent_validation){
    var format = _field.getAttribute('data-format');

    if(!format || format == '') return true;

    var _parent = _field.getParent('li') || _field.getParent();
    _parent.removeClass('_failed');

    var value = _field.get('value').trim();
    var re;

    if(format == 'password'){
      re = /^([^\']+)$/;
    }else if(format == 'email'){
      re = /^[a-zA-Z0-9!#$%&\'*+\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&\'*+\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;
    }else if(format == 'phone'){
      re = /^([+]?[0-9 \.\-]+)$/;
    }

    var valid = re.test(value);

    if(!valid && !silent_validation){
      this.show_advice(_field, 'data-error-format', 'Please use correct format for this field');
    }

    return valid;
  },

  check_budget: function(_field, silent_validation){
    if(!_field || !_field.getParent('._budget')) return true;

    var _radio = this._signup_form.getElement('.w_styled_radio li._selected input');

    if(!_radio) return true;

    var min_price = _radio.getAttribute('data-min-price');
    var max_price = _radio.getAttribute('data-max-price');

    var budget = _field.get('value').replace(/,/g, '').toInt();

    var valid = true;

    if(budget < min_price){
      if(!silent_validation){
        this.show_advice(_field, 'data-error-min_budget', 'Minimum budget is $' + Core.add_commas(min_price));
      }

      valid = false;
    }else if(budget > max_price){
      if(!silent_validation){
        this.show_advice(_field, 'data-error-max_budget', 'Maximum budget is $' + Core.add_commas(max_price));
      }

      valid = false;
    }

    return valid;
  },

  show_advice: function(_field, data_property, generic_message, use_gm){
    var self = this;
    var _parent = _field.getParent('li') || _field.getParent();
    _parent.addClass('_failed');
    _field.removeClass('_valid');

    var msg = (!use_gm && _field.getAttribute(data_property))? _field.getAttribute(data_property) : generic_message;

    if(!msg || msg == '') return;

    this._validation_advice.text.set('html', msg);

    this._validation_advice.getStyle('right').toInt();

    this._validation_advice.show();

    var height = this._validation_advice.getSize().y;
    var top;
    var center;

    if(_field.isDisplayed()){
      top = _field.getCoordinates(this._element).top;
      center = top + _field.getSize().y / 2;
    }else{
      var _el = _field.getParent();

      while(!_el.isDisplayed()){
        _el = _el.getParent();
      }

      top = _el.getCoordinates(this._element).top;
      center = top + _el.getSize().y / 2;
    }

    top = center - height / 2;

    this._validation_advice.setStyles({
      'top': top
    });

    this.showing_error = true;

    if(_field.hasClass('._email')){
      this._validation_advice.addClass('_email');
    }else{
      this._validation_advice.removeClass('_email');
    }

    if(!_log_in){
      var _log_in = this._validation_advice.getElement('.log_in');

      if(_log_in){
        _log_in.addEvent('click', function(e){
          if(e && e.stop) e.stop();

          if(!self.active) return;

          self._signin_toggle.fireEvent('click');
        }.bind(this));
      }
    }
  },

  hide_advice: function(){
    this._validation_advice.hide();
    this.showing_error = false;

    var _login_error = this._element.getElement('.login_failed');

    if(_login_error){
      _login_error.hide();
    }
  },

  errors_cleanup: function(){
  	this.hide_advice();

  	this._element.getElements('*').removeClass('_failed');
  },

  add_slider: function(){
    var self = this;

    var signin_input = this._signin_form.getElement('input[type="text"]');
    var signup_input = this._signup_form.getElement('input[type="text"]');

    this.slider = new Fx.Slide(this._signup_form, {
      onComplete: function(){
      	(function(){
	        if(this.open){
	        	if(!Core.is_touch_supported()){
	          	self.focus(signup_input);
	          }
	          self._signin_form.fade('hide');
	        }else{
	          if(!Core.is_touch_supported()){
	          	self.focus(signin_input);
	          }
	          self._signup_form.fade('hide');
	        }
	      }.bind(this)).delay(20);
      }
    });
  },

  slide: function(how){
    if(!this.slider){
      this.add_slider();
    }

    this.hide_advice();

    if(how == 'in'){
      this._signup_form.fade('show');
      this.slider.slideIn();
    }else if(how == 'out'){
      this._signin_form.fade('show');
      this.slider.slideOut();
    }
  },

  inject_name: function(){
    var fn = this._element.getElement('#first_name_li input').get('value');
    var ln = this._element.getElement('#last_name_li input').get('value');

    this._element.getElements('.title .first_name').set('text', fn);
    this._element.getElements('.title .last_name').set('text', ln);
  },

  display_second_step: function(){
    var self = this;

    this.addQuancastScript();

    this._element.getElements('.first_step').each(function(_el){
      _el.hide();
    });

    this._element.getElements('.second_step').each(function(_el){
      _el.show();
    });

    this.fireEvent('secondStep');

    (function(){
      self.ready_for_signup = true;
    }).delay(1000);
  },

  display_second_step_errors: function(data){
    if(data.FormRegistrationPopup_budget && data.FormRegistrationPopup_budget[0]){
      return {'budget': data.FormRegistrationPopup_budget[0]};
    }else if(data.FormRegistrationPopup_phone && data.FormRegistrationPopup_phone[0]){
      return {'phone': data.FormRegistrationPopup_phone[0]};
    }

    return false;
  },

  display_thankyou: function(){
    var self = this;

    this._element.getElements('.second_step, .first_step').each(function(_el){
      _el.hide();
    });

    this._element.getElement('.slider').hide();

    this._thankyou_form = this._element.getElement('.w_form.thankyou');
    this._thankyou_form.form = this._thankyou_form.getElement('form');

    this._element.getElement('.feature._confidential').hide();

    if(this._element.getElement('.w_info._registration')){
    	this._element.getElement('.w_info._registration').hide();
    }

    this._element.getElements('.thankyou').each(function(_el){
      _el.show();
    });

    (this._element.getElement('.w_popup._registration') || this._element).addClass('_thankyou');

    this.fireEvent('thankyou');

    var _textarea = this._element.getElement('.thankyou textarea');

    //since this form is different from the first and second step, in FormSupport.js,
    //this element will not be included when we get all the input and textarea element
    if(!_textarea.getProperty('placeholder') || Core.is_ie11()){
			new TextOver(_textarea);
		}

    self.focus(_textarea);

    var close = true;

    _textarea.addEvents({
      'click': function(){
        close = false;
      },

      'keydown': function(){
        close = false;
      }
    });

    var _submit = this._thankyou_form.getElement('input[type="submit"]');

    this._thankyou_form.form.addEvent('submit', function(e){
      e.preventDefault();
      close = false;

      if(!self.active) return;

      if(_textarea.get('value') == ''){
        Core.shake_element(_submit);
        self.focus(_textarea);

        return;
      }

      self._thankyou_form.addClass('_loading');
      self.active = false;

      new Request.JSON({
        data: self._thankyou_form.form.toQueryString(),
        url: self._thankyou_form.form.getProperty('action'),
        noCache: true,

        onSuccess: function(data){
          self._thankyou_form.removeClass('_loading');
          self._thankyou_form.addClass('_comment_sent');
          self.active = true;

          (function(){
            self.active = false;
            self.post_signup();
          }).delay(2000);
        }
      }).post();
    });

    var _countdown = this._element.getElement('.thankyou._countdown span');

    var sec_before_close = 8;

    _countdown.set('text', sec_before_close);

    var interval = setInterval(function(){
      if(!close){
        _countdown.getParent().set('html', '&nbsp;');
        clearInterval(interval);
        return;
      }

      if(sec_before_close > 0){
        sec_before_close--;
        _countdown.set('text', sec_before_close);
      }else{
        clearInterval(interval);
      }
    }, 1000);

    (function(){
      if(close){
        self.active = false;
        self.post_signup();
      }
    }).delay(sec_before_close * 1000);
  },

  fix_tab_key: function(){ //need this fix because by default tabkey scrolls the slider and in some condition even goes to the second step
    var self = this;

    this._element.addEvent('keydown', function(e){
      if(e && e.code == 9){
        e.preventDefault();
      }
    });

    var _tabbables = this._element.getElements('input[type!="hidden"], a');

    _tabbables.each(function(_el, i){
      _el.addEvent('keydown', function(e){
        if(e && e.code == 9){
          var _next = (i >= _tabbables.length)? _tabbables[0] : _tabbables[i+1];

          if(Core.is_visible(_next) && _el.getParent('form') === _next.getParent('form')){
            self.focus(_next);
          }
        }
      });
    });
  },

  focus: function(_el){
    _el.focus();
  },

  add_hidden_input: function(_el){
  	var _signin_ol = this._signin_form.getElement('ol');

  	if(!_el.get('data-listing-token')) return;

  	var _hidden_input_action = new Element('input', {
			'type':'hidden',
			'value':'save-listing',
			'id':'RPCFormLogin_action',
			'name':'RPCFormLogin[action]'
		});

		var _hidden_input_token = new Element('input', {
			'type':'hidden',
			'value': _el.get('data-listing-token'),
			'id':'RPCFormLogin_token',
			'name':'RPCFormLogin[token]'
		})

		if(_signin_ol){
			_hidden_input_action.inject(_signin_ol);
			_hidden_input_token.inject(_signin_ol);
		}
  },

  remove_hidden_input: function(){
  	if(!this._signin_form) return;

  	var _hidden_input_action = this._signin_form.getElement('input#RPCFormLogin_action');
	var _hidden_input_token = this._signin_form.getElement('input#RPCFormLogin_token');

	if(_hidden_input_action && _hidden_input_token){
		_hidden_input_action.dispose();
		_hidden_input_token.dispose();
	}
  },

  show_save_listing_message: function(data){
  	if(this._signin_form.getElement('#RPCFormLogin_action') && this._signin_form.getElement('#RPCFormLogin_token') && data.RPCFormLogin_FORMSUMMARY[0]['message']){
      var _success_message = new Element('.save_listing_message', {'html': data.RPCFormLogin_FORMSUMMARY[0]['message']});
      _success_message.inject(this._element.getElement('.w_form._sign_in form'), 'after');
    }
  },

  addQuancastScript: function(){
  	var script = 'var _qevents = _qevents || [];' +
								'(function() {' +
								'var elem = document.createElement(\'script\');' +
								'elem.src = (document.location.protocol == "https:" ? "https://secure" : "http://edge") + ".quantserve.com/quant.js";' +
								'elem.async = true;' +
								'elem.type = "text/javascript";' +
								'var scpt = document.getElementsByTagName(\'script\')[0];' +
								'scpt.parentNode.insertBefore(elem, scpt);' +
								'})();' +

								'_qevents.push(' +
								'{qacct:"p-X8cce6pn6bvF-",labels:"_fp.event.Registration"}' +
								');';

		if(!window['_qevents']){
	 		var s = new Element('script');
	 		s.set('html', script);

	 		var ns = new Element('noscript');
	 		ns.set('html', '<img src="//pixel.quantserve.com/pixel/p-X8cce6pn6bvF-.gif?labels=_fp.event.Registration" style="display: none;" border="0" height="1" width="1" alt="Quantcast"/>');

	 		document.body.grab(s);
	 		document.body.grab(ns);
	  }
  }
});
